<template>
  <div class="error-401 mt-12">
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <h1>{{ $t("app.401.title") }}</h1>
          <p>{{ $t("app.401.message-1") }}</p>
          <p>{{ $t("app.401.message-2") }}</p>
          <Login></Login>
          <v-btn block @click="$router.go(-1)">
            {{ $t("app.buttons.back") }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Login from "./Login";

export default {
  components: {
    Login
  }
};
</script>
